<template>
  <div>
    <v-btn color="green" class="mt-3" icon x-large @click="dialog = true">
      <v-icon>mdi-plus-box</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" persistent width="600">
      <v-card>
        <ModalHeader
          title="Add Service"
          icon="mdi-plus-box"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-text-field
            outlined
            dense
            label="Service Name"
            v-model="form.service_name"
            prepend-icon="mdi-tools"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Service Amount"
            v-model="form.service_amount"
            prepend-icon="mdi-cash"
            type="number"
          ></v-text-field>
          <v-autocomplete
            outlined
            dense
            label="Account Title"
            v-model="form.chart_of_account_id"
            :items="chart_of_accounts"
            item-text="account_title"
            item-value="id"
            prepend-icon="mdi-book-open-variant"
            clearable
          ></v-autocomplete>
          <v-text-field
            outlined
            dense
            label="Profitable Margin %"
            v-model="form.profitable_margin"
            prepend-icon="mdi-percent"
            type="number"
          ></v-text-field>
          <v-checkbox
            v-model="form.is_fee"
            prepend-icon="mdi-receipt-text-outline"
            label="Tax / on-top fee (not a real service)"
            hint="Excluded from service revenue in performance reports"
            persistent-hint
          ></v-checkbox>
          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                label="Warranty Count"
                v-model="form.warranty_count"
                prepend-icon="mdi-shield-check"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                outlined
                dense
                label="Warranty Duration"
                v-model="form.warranty_duration"
                :items="warrantyDurations"
                prepend-icon="mdi-clock-outline"
                clearable
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit" color="primary" :loading="loading">Add</v-btn>
          <v-btn @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
      dialog: false,
      warrantyDurations: ["Day/s", "Week/s", "Month/s", "Year"],
      form: {
        service_name: "",
        service_amount: "",
        chart_of_account_id: 3,
        profitable_margin: "",
        is_fee: false,
        warranty_count: "",
        warranty_duration: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      chart_of_accounts: "chart_of_account/chart_of_accounts",
    }),
  },
  methods: {
    ...mapActions({
      add_service: "service/add_service",
      get_chart_of_accounts: "chart_of_account/get_chart_of_accounts",
    }),
    async submit() {
      if (!this.form.service_name || !this.form.service_amount) {
        this.$alert({
          title: "Validation",
          message: "Service Name and Service Amount are required.",
          color: "warning",
          icon: "mdi-alert",
        });
        return;
      }
      this.loading = true;
      try {
        await this.add_service(this.form);
        this.$alert({
          title: "Success",
          message: "Successfully added a new service!",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.dialog = false;
        this.resetForm();
      } catch (error) {
        console.error("Error adding service:", error);
        this.$alert({
          title: "Error",
          message: "Failed to add service. Please try again.",
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = {
        service_name: "",
        service_amount: "",
        chart_of_account_id: 3,
        profitable_margin: "",
        is_fee: false,
        warranty_count: "",
        warranty_duration: "",
      };
    },
  },
  async created() {
    if (this.chart_of_accounts.length === 0) await this.get_chart_of_accounts();
  },
};
</script>

<style lang="scss" scoped></style>
